import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GuenstigerWirkstoff, WarenkorbPosition, WarenkorbPositionApi } from './warenkorb';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { Observable, throwError } from 'rxjs';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';

@Injectable({ providedIn: 'root' })
export class WarenkorbService {
    constructor(
        private http: HttpClient,
        private localStorageService: LocalStorageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    getWarenkorbContent(laborartikelOnly?: boolean): Observable<WarenkorbPositionApi> {
        if (!this.localStorageService.hasPermission(1771) && !this.localStorageService.hasPermission(1082)) {
            return throwError(null);
        }
        let url = this.apiBaseUrl + 'warenkorb/read.php';
        if (laborartikelOnly === true) {
            url += '?laborartikel=1';
        } else if (laborartikelOnly === false) {
            url += '?laborartikel=0';
        }
        return this.http.get<WarenkorbPositionApi>(url);
    }

    updateWarenkorbPosition(w: WarenkorbPosition): Observable<WarenkorbPosition> {
        return this.http.post<WarenkorbPosition>(this.apiBaseUrl + 'warenkorb/update.php', w);
    }

    deleteWarenkorbPosition(w: WarenkorbPosition) {
        return this.http.post(this.apiBaseUrl + 'warenkorb/delete.php', w);
    }

    addArticleToWarenkorb(
        articleId: number,
        amount: number,
        kommentar: string,
        labor = false,
    ): Observable<WarenkorbPosition> {
        const w = new WarenkorbPosition();
        w.artikel_id = articleId;
        w.menge_soll = amount;
        w.kommentar = kommentar;
        w.status_id = 31;
        w.labor = labor ? 1 : 0;
        return this.http.post<WarenkorbPosition>(this.apiBaseUrl + 'warenkorb/update.php', w);
    }

    addWarenkorbPositionToWarenkorb(wkp: WarenkorbPosition): Observable<WarenkorbPosition> {
        return this.addArticleToWarenkorb(wkp.artikel_id, wkp.menge_soll, wkp.kommentar, false);
    }

    guenstigerWirkstoff(artikelId: number): Observable<GuenstigerWirkstoff> {
        const params = new HttpParams().set('artikel_id', String(artikelId));
        return this.http.get<GuenstigerWirkstoff>(this.apiBaseUrl + 'warenkorb/read_guenstiger_wirkstoff.php', {
            params,
        });
    }

    releaseWarenkorb(labor = false) {
        return this.http.post(this.apiBaseUrl + 'warenkorb/freigeben.php', { labor: labor ? 1 : 0 });
    }

    updateShoppingCartBadge() {
        this.getWarenkorbContent().subscribe(response => {
            const len = response.count;
            this.localStorageService.setNumberOfShoppingCartItems(len);
        });
    }
}
